import { GrupoRow } from 'src/modules/grupo/grupo.types'
import { Observable, observe, Scope } from 'wdc-cube'
import { BorderoEnvio } from '../bordero.types'

@Observable
export class BorderoFormScope extends Scope {
    @observe() gruposAtivos = [] as GrupoRow[]
    @observe() formData = {} as BorderoEnvio

    onFileChange = Scope.ASYNC_ACTION_ONE<File | undefined>()
    onFormDataChange = Scope.ASYNC_ACTION_ONE<Partial<BorderoEnvio>>()

    onSave = Scope.ASYNC_ACTION
    onClose = Scope.ASYNC_ACTION
}

export default BorderoFormScope
